export const SET_SELECTED_PRODUCT = 'PENDING_GUARANTEES/SET_SELECTED_PRODUCT';
export const RESET_SELECTED_PRODUCT = 'PENDING_GUARANTEES/RESET_SELECTED_PRODUCT';
